"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameInfo = void 0;
const APIEventSystem_1 = require("../../interfaces/APIEventSystem");
class GameInfo {
    constructor(api) {
        this._api = api;
        this.displayName = api.options.game;
        api.events.on(APIEventSystem_1.APIEvent.GAME_INFO, (data) => this.onGameInfo(data));
    }
    updateScreen(screen) {
        const maxMultipliers = screen.find('span.maxMultiplier');
        for (let element of maxMultipliers) {
            element.innerHTML = this._maxMultiplier;
        }
        const maxMultiplierProbability = screen.find('span.maxMultiplierProbability');
        for (let element of maxMultiplierProbability) {
            element.innerHTML = this._maxMultiplierProbability;
        }
    }
    onGameInfo(data) {
        this.displayName = data.displayName;
        this._maxMultiplier = data.maxMultiplier;
        this._maxMultiplierProbability = "1:" + data.maxMultiplierProbability;
    }
    updateDom() {
        const nameTag = document.querySelector('#game-name-version');
        if (nameTag) {
            nameTag.innerHTML = this.displayName;
        }
    }
    set formattedRtp(value) {
        this._formattedRtp = value;
        //If old solution with german info in game name, do nothing
        if (this.displayName.indexOf("Höchstgewinnwahrscheinlichkeit") == -1) {
            if (this._api.gameClientConfiguration.showRtpWatermark) {
                this.displayName += ", " + this._api.translations.translate("Rtp:") + " " + this._formattedRtp;
            }
            if (this._api.gameClientConfiguration.showMaxWinProbabilityWatermark) {
                this.displayName += ", " + this._api.translations.translate("Max win probability:") + " " + this._maxMultiplierProbability;
            }
        }
        this.updateDom();
    }
}
exports.GameInfo = GameInfo;
//# sourceMappingURL=GameInfo.js.map